'use client';

export const AnchorTarget = ({ id }: { id: string }) => {
  return <div id={id}></div>;
};
AnchorTarget.displayName = 'AnchorTarget';
